// extracted by mini-css-extract-plugin
module.exports = {"avatar":"zrUlyA","noSrc":"_1kQ4qB","circle":"_1NCbjX","shine-lines":"_31APOr"};